<script lang="ts">
	import type { LookalikeModelRow } from 'Lookalike';
	import Spinner from '../Spinner.svelte';
	import { asyncTimeout } from '../../utils';
	import { createEventDispatcher, onMount } from 'svelte';
	import { getClient, mutate } from 'svelte-apollo';
	import { mutationCheckStatusLookalikeModelRow } from '../../graphql/queries/lookalike';

	const dispatch = createEventDispatcher();
	const client = getClient();

	export let row: LookalikeModelRow;

	const statusCheckOp = (values: { runId: number; rowId: number }) => {
		const { runId, rowId } = values;
		return new Promise((resolve) =>
			mutate(client, {
				mutation: mutationCheckStatusLookalikeModelRow,
				variables: {
					runId: runId,
					rowId: rowId
				},
				errorPolicy: 'all'
			})
				.then((dataResponse) => {
					resolve(dataResponse);
				})
				.catch((err) => {
					console.warn(err);
					resolve({ errors: err });
				})
		);
	};

	onMount(() => {
		handleStatusChange();
	});

	const handleStatusChange = async () => {
		if (row.status === 'PENDING') {
			await statusCheckOp({
				rowId: row.id,
				runId: row.jobId
			})
				.then(() => {})
				.catch((err) => {
					console.warn(err);
				});

			dispatch('refresh');
			await asyncTimeout(10000);

			return handleStatusChange();
		}
	};
</script>

{#if row.status === 'SUCCESS'}
	<span class="green">SUCCESS</span>
{:else if row.status === 'PENDING'}
	<div class="table-spinner">
		<Spinner />
	</div>
{:else}
	<span class="red">FAILED</span>
{/if}

<style lang="scss">
	.green {
		color: rgb(61, 153, 110);
	}

	.red {
		color: red;
	}

	.table-spinner :global(.spinner) {
		font-size: 20px !important;
		margin-left: 0 !important;
		margin-right: 0 !important;
		margin-top: 22px !important;
		margin-bottom: 22px !important;
	}
</style>
